import { injectMemCommonEditorGlobalStyles } from "@mem-labs/common-editor";
import { backendApiClientManager } from "@/managers/backend-api-client";
import { loggerClientManager } from "@/managers/logging-client";
import { lowlightModule } from "@/modules/lowlight";

export const initializeGlobalState = async () => {
  injectMemCommonEditorGlobalStyles();
  await backendApiClientManager.initialize({});
  await loggerClientManager.initialize({});

  lowlightModule.initialize();
};
